import styled from '@emotion/styled';
import { fontSize } from '@styles/globalStyles';
import { breakpoint } from '@styles/breakpoints';

export const Employer = styled.a`
  height: 300px;
  padding: 16px;
  background-color: #fff;
  box-shadow: ${({ theme }) => theme.shadow.medium};
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;
  cursor: pointer;
  text-decoration: none;
  flex: 0 0 calc(25% - 24px);

  @media only screen and ${breakpoint.xl} {
    min-width: 31%;
  }

  @media only screen and (max-width: 944px) {
    min-width: 48%;
  }

  @media only screen and (max-width: 830px) {
    min-width: 100%;
  }
`;

export const Logo = styled.div`
  width: 100%;
  height: 70%;
  margin-bottom: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    display: block;
    width: 70%;
    height: 70%;
    object-fit: contain;
    margin: 0 auto;
  }
`;

export const CompanyName = styled.p`
  font-family: ${({ theme }) => theme.defaults.fontFamily.secondary};
  font-size: ${fontSize(18)};
  line-height: 1.4;
  color: #00202d;
  text-align: left;
  text-transform: uppercase;
`;

export const Industry = styled.p`
  margin: 8px 0 0;
  font-size: ${fontSize(14)};
  text-transform: uppercase;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.14;
  letter-spacing: -0.21px;
  color: #009fe3;
  text-align: left;
`;

export const PreloaderContainer = styled.div`
  width: 100%;
  height: 100%;

  div {
    height: calc(100% - 20px);
    left: 50%;
    top: 50%;
    transform: translate3d(-10px, -10px, 0);
  }
`;
